import type { ReferralV1Hook } from './types/referral.type';
import { BaseHookResult, createVersionedHook } from './utils/createVersionHooks';
import { useReferralV1 } from './v1';
import { useReferralV2 } from './v2/useReferralV2';

interface UseReferral extends ReferralV1Hook, BaseHookResult {}

export const useReferral = createVersionedHook<UseReferral>(
  {
    v1: useReferralV1,
    v2: useReferralV2,
  },
  'useReferral',
);
